import { mockCmsPicture } from '@domgen/dgx-fe-cms';
import { CmsArticleSearchForm } from '../../models/article-search/cms/cms-article-search-form.interface';

export const mockCmsArticleSearchForm: CmsArticleSearchForm = {
  quickLinks: [],
  theme: 'background',
  articleSearchBody: 'body',
  articleSearchIntro: 'intro',
  picture: mockCmsPicture,
  articleSearchTitle: 'title',
};
